import { ModelBase } from 'store/model-base';

export class CmsByodExchange extends ModelBase {
    public static storeName: string = 'cmsByodExchange';

    public breadcrumbs: CmsSimSwapBreadcrumbs;
    public review: CmsByodExchangePairSimReview;
    public success: CmsByodExchangePairSimResult;
    public failure: CmsByodExchangePairSimResult;
    public pending: CmsByodExchangePairSimResult;
    public inProgress: CmsByodExchangePairInProgress;
}
